import { ReactElement } from 'react';
import { Params, useParams } from 'react-router';

interface RouteParamsProps {
  children: (params: Params<string>) => ReactElement;
}

function RouteParams(props: RouteParamsProps) {
  const { children } = props;

  return children(useParams());
}

export default RouteParams;
